<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
			:dialog-class="''"
			:ok-title="'Search'"
			ok-variant="success"
			:cancel-title="'Clear'"
			@ok="getReportTracingAbilitys"
			@hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="filterControlCards" optionsLabel="name" optionsKey="name" label-cols-sm="4" label-cols-lg="3" label="Control Card" id="filter-" size="sm" :model.sync="filter.controlCardNumber" @input="getFilterControlCards" @focus="getFilterControlCards" />
						<!-- <app-input-textbox id="fieldset-filter-transaction-type" label-cols-sm="4" label-cols-lg="3" label="Transaction Type " label-for="filter-filter-transaction-type" size="sm" :model.sync="filter.filterTransactionType" /> -->
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="filterControlCardTypes" optionsLabel="name" optionsKey="code" label-cols-sm="4" label-cols-lg="3" label="Control Card Type " id="filter-" size="sm" :model.sync="filter.controlCardType" @input="getControlCardTypes" @focus="getControlCardTypes" />
						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportTracingAbilitys"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
						   rounded
						   opacity="0.6"
						   spinner-small
						   spinner-variant="primary"
						   class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report Tracing Ability</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-reporttracingability" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="light" :bordered="true" :no-local-sorting="true" :items="reportTracingAbilitys" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="reportTracingAbilitys.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="ControlCardType" class="table-filter">
							<v-select append-to-body label="code" :options="filterControlCardTypes" :value="filter.controlCardType" :reduce="item => item.id" v-model="filter.controlCardType" :filterable="true" @input="getReportTracingAbilitysWithoutLoading" @search="getControlCardTypes"></v-select>
						</b-th>
						<b-th stacked-heading="ControlCardNumber" class="table-filter">
							<b-form-input id="input-control-card-number-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.controlCardNumber" size="sm"></b-form-input>
						</b-th>
				<!-- <b-th stacked-heading="PartNumber" class="table-filter">
					<b-form-input id="input-part-number-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.partNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Customer Code" class="table-filter">
					<b-form-input id="input-customer-name-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.customerName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Supplier Code" class="table-filter">
					<b-form-input id="input-supplier-code-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.supplierCode" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Incoming Date" class="table-filter">
					<b-form-input id="input-incoming-date-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.incomingDate" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Transaction Date" class="table-filter">
					<b-form-input id="input-transaction-date-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.transactionDate" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Transaction Type" class="table-filter">
					<b-form-input id="input-transaction-type-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.transactionType" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Before" class="table-filter">
					<b-form-input id="input-qty-before-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.qtyBefore" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty After" class="table-filter">
					<b-form-input id="input-qty-after-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.qtyAfter" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Rack Before" class="table-filter">
					<b-form-input id="input-rack-before-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.rackBefore" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Rack After" class="table-filter">
					<b-form-input id="input-rack-after-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.rackAfter" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Area Before" class="table-filter">
					<b-form-input id="input-area-before-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.areaBefore" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Area After" class="table-filter">
					<b-form-input id="input-area-after-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.areaAfter" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Source Case" class="table-filter">
					<b-form-input id="input-source-case-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.sourceCase" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Status" class="table-filter">
					<b-form-input id="input-statuss-table" @input="getReportTracingAbilitysWithoutLoading" v-model="filter.statuss" size="sm"></b-form-input>
				</b-th> -->

					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<!-- <template v-slot:cell(productionHistory)="row">
						<span v-if="row.item.qtyBefore > 0 && row.item.transactionType == 'RECEIPT FROM PRODUCTION' && hasDetail(row.item)">
							<b-button class="ml-2 mt-2 mt-sm-0 btn-outline-success" @click="goToDetail(row.item)" size="sm">Production History</b-button>
						</span>
						<span v-else>&nbsp;</span>
					</template> -->

					<!-- <template v-slot:cell(controlCardType)="row">
						{{ row.item.controlCardType + " " }}
						<span v-if="row.item.qtyBefore > 0 && row.item.transactionType == 'RECEIPT FROM PRODUCTION' && hasDetail(row.item)">
							<b-button class="ml-2 mt-2 mt-sm-0 btn-outline-success" @click="goToDetail(row.item)" size="sm"><b-icon-eye /></b-button>
						</span>
					</template> -->

					<template v-slot:cell(controlCardNumber)="row">
						<!-- <span v-if="row.item.qtyBefore > 0 && row.item.transactionType == 'RECEIPT FROM PRODUCTION' && hasDetail(row.item)"> -->
							<!-- <span class="link-detail" @click="goToDetail(row.item)">{{ row.item.controlCardNumber }}</span> -->
						<!-- </span> -->
						<!-- <span v-else> -->
							{{ row.item.controlCardNumber }}
						<!-- </span> -->
						
					</template>
			<template v-slot:cell(transactionDate)="row">
				{{ row.item.transactionDate | moment("DD-MMM-YYYY") }}
			</template>

					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-textbox id="fieldset-customer-name" label-cols-lg="12"  label="Customer Code" label-for="input-customer-name" size="sm" :model.sync="row.item.customerName"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-part-number" label-cols-lg="12"  label="PartNumber" label-for="input-part-number" size="sm" :model.sync="row.item.partNumber"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-supplier-code" label-cols-lg="12"  label="Supplier Code" label-for="input-supplier-code" size="sm" :model.sync="row.item.supplierCode"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-qty-after" label-cols-lg="12"  label="Qty After" label-for="input-qty-after" size="sm" :model.sync="row.item.qtyAfter"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-area-after" label-cols-lg="12"  label="Area After" label-for="input-area-after" size="sm" :model.sync="row.item.areaAfter"   :isEditable="false" :isUpdatable="true" />
						<app-input-textbox id="fieldset-rack-after" label-cols-lg="12"  label="Rack After" label-for="input-rack-after" size="sm" :model.sync="row.item.rackAfter"   :isEditable="false" :isUpdatable="true" />
						
						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
											  v-model="currentPage"
											  :total-rows="(reportTracingAbilitysPaging != null ? reportTracingAbilitysPaging.dataCount : 0)"
											  :per-page="(reportTracingAbilitysPaging != null ? reportTracingAbilitysPaging.pageSize : 0)"
											  aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />

		<Detail :openPopup="isShowPopUpDetail"
			label="Tracing Ability Detail"
			:parentData="parentObj"
			@resetModalMethod="resetModal"
		/>
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-reporttracingability.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-reporttracingability.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ReportTracingAbility from '@/models/ReportTracingAbility/ReportTracingAbility';
import ReportTracingAbilityList from '@/models/ReportTracingAbility/ReportTracingAbilityList';
import ReportTracingAbilityFilter from '@/filters/ReportTracingAbility/ReportTracingAbilityFilter';
import RoleDetail from '@/models/Core/RoleDetail';
import Detail from '@/views/ReportTracingAbility/Detail';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import ControlCardType from '@/models/ControlCardType/ControlCardType';

export default {
	components : {
		ReportTracingAbility, 
		ReportTracingAbilityList, 
		ReportTracingAbilityFilter, 
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
		Detail,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : {"class" : "th-number d-stack-none"}},
				{"customerName": {}, "class" : "th-customer-name d-stack-none", "label" : "Customer Name", key: 'customerName', }, 
				{"partNumber": {}, "class" : "th-part-number last-child", "label" : "Part Number", key: 'partNumber', }, 
				{"partClassification": {}, "class" : "th-part-classification d-stack-none", "label" : "Part Classification", key: 'partClassification', }, 
				{"supplierCode": {}, "class" : "th-supplier-code d-stack-none", "label" : "Supplier Code", key: 'supplierCode', }, 
				{"lineCode": {}, "class" : "th-line-code d-stack-none", "label" : "Line Code", key: 'lineCode', }, 
				{"rackCode": {}, "class" : "th-rack-code d-stack-none", "label" : "Rack Code", key: 'rackCode', }, 
				{"seqProcess": {}, "class" : "th-seq-process d-stack-none", "label" : "Seq Process", key: 'seqProcess', }, 
				{"pic1": {}, "class" : "th-pic-1 d-stack-none", "label" : "Rack Code", key: 'pic1', }, 
				{"pic2": {}, "class" : "th-pic-2 d-stack-none", "label" : "Rack Code", key: 'pic2', }, 
				{"areaName": {}, "class" : "th-area-name d-stack-none", "label" : "Area Name", key: 'areaName', }, 
				{"transactionType": {}, "class" : "th-transaction-type d-stack-none", "label" : "Transaction Type", key: 'transactionType', }, 
				{"transactionDate": {}, "class" : "th-transaction-date d-stack-none", "label" : "Transaction Date", key: 'transactionDate', }, 
				{"controlCardNumber": {}, "class" : "th-control-card-number", "label" : "Control Card Number", key: 'controlCardNumber', }, 
				{"qtyAfter": {}, "class" : "th-qty-after d-stack-none", "label" : "Qty After", key: 'qtyAfter', }, 
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportTracingAbilitys: [],
			reportTracingAbilitysPaging: {},
			filterControlCards : [],
			filterTransactionTypes : [],
			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			parentObj: {},
			isShowPopUpDetail: false,
			idDataWithDetail: [],
			filterControlCardTypes: [],
		}
	},	methods : {
		getControlCardTypes: async function (input) {
			let filter = {};
			if(input != null)
			{
				filter.code = input;
			}
			let result = await ControlCardType.getList(this, filter, null, 0, 10);
			this.filterControlCardTypes = result.data;
		},
		hasDetail(item) {
			if(!item || this.idDataWithDetail.length == 0) return false;
			let result = this.idDataWithDetail.includes(item.tempId);
			
			if(result) return true;
			return false;
		},
		goToDetail(parentData) {
			this.parentObj = parentData;
			this.isShowPopUpDetail = true;
		},
		getReportTracingAbilitys : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			if(this.filter.controlCardNumber)
			{
				this.filter.exactType.controlCardNumber = 1
			}
			if(this.filter.controlCardType)
			{
				this.filter.exactType.controlCardType = 1
			}
			ReportTracingAbility.getListCustomUrl(this, 'getlistcustom', this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportTracingAbilitys = result.data;
					// this.reportTracingAbilitysPaging = result
					if(result.fields != null && result.fields.length > 0)
					{
						this.fields = result.fields;
					}
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReportTracingAbilitysWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			await ReportTracingAbility.getListCustomUrl(this, 'getlistcustom', this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				console.log("result get list", result);
				if (result != null) {
					this.reportTracingAbilitys = result.data
					this.reportTracingAbilitysPaging = result
				}
			})
			.catch(error => {});
		},
		getFilterControlCards : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportTracingAbility.getListCustomUrl(this,'getlistfiltercontrolcard' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterControlCards = result.data
				}
			})
			.catch(error => {});
		},
		getFilterTransactionTypes : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportTracingAbility.getListCustomUrl(this,'getlistfiltertransactiontype' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterTransactionTypes = result.data
				}
			})
			.catch(error => {});
		},

		/*getDataWithDetail : async function() {
			const response = await this.$http.get(`ReportTracingAbility/dataidswithdetail`);
			if(response && response.data) {
				this.idDataWithDetail = response.data;
			}
		},*/

		resetFilter() {
			this.filter = new ReportTracingAbilityFilter();
			this.getReportTracingAbilitys();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
			this.isShowPopUpDetail = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportTracingAbilitys();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportTracingAbility.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportTracingAbility.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			ReportTracingAbility.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportTracingAbility.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportTracingAbilitys();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportTracingAbility.deleteMultipleData(this).then(result => {
					this.getReportTracingAbilitys();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportTracingAbilityParent = document.getElementById('table-list-reporttracingability').parentNode;
			tableReportTracingAbilityParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportTracingAbilityParent.scrollWidth - tableReportTracingAbilityParent.offsetWidth) == Math.ceil(tableReportTracingAbilityParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportTracingAbilityParent = document.getElementById('table-list-reporttracingability').parentNode;
			tableReportTracingAbilityParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportTracingAbilityParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	async beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportTracingAbilityFilter();
		// await this.getFilterControlCards();
		//await this.getDataWithDetail();
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report Tracing Ability"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportTracingAbilitys();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportTracingAbilitys();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportTracingAbilitys();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportTracingAbilitys();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportTracingAbilitys();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportTracingAbility.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reporttracingabilityindex") {
					this.getReportTracingAbilitysWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_tracing_ability").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
